import { Select } from "@chakra-ui/react"
import { ContactSelectProps } from "@definitions/types"
import { Controller } from "react-hook-form"
import { MdArrowDropDown } from "react-icons/md"

const ContactSelect = ({
  id,
  placeholder,
  options,
  defaultValue,
  onCountryChange,
  ...props
}: ContactSelectProps) => {
  return (
    <Controller
      {...props}
      render={({ field: { onChange, value, ref, ...restField } }) => (
        <Select
          id={id}
          variant={"flushed"}
          placeholder={!value ? "  " : placeholder}
          fontSize={"2xl"}
          icon={<MdArrowDropDown />}
          borderColor={"brand.black"}
          focusBorderColor={"brand.primary"}
          iconColor={"brand.black"}
          color={"brand.primary"}
          defaultValue={defaultValue}
          onChange={(e) => {
            onChange(e.target.value)
            if (onCountryChange) {
              onCountryChange(e.target.value)
            }
          }}
          ref={ref}
          {...restField}
        >
          {options.map((option, index) => (
            <option
              key={index}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </Select>
      )}
    />
  )
}

export default ContactSelect
